/* 1500 Hours · v3 card builder (sections/h15-builder.liquid), 2026-10-13. The store v3 builder on the card PDPs.

   ORDER DATA = addon-widget.js's atomic add, line for line (that file is the reference; keep the tables in step):
     card line   { id: card variant, quantity, properties: { Airport | checkride fields | Airline + ICAO + Callsign,
                   every selected add-on's CARD_PROPS keys, _h15: group (only when an add-on is on) } }
     charge line { id: helper variant (personalization-card-add-on, by title), quantity: same,
                   properties: { for: "<ref> card", _h15: group } }   one per paid add-on
   in ONE /cart/add.js write. Checkride keys are Globo's own names (checkride, name on card, date passed, back of
   card and/or their ride (cfi name and home field)). addon-guard.js reconciles the pair; it reads the add-on
   table this file publishes (addon-widget.js is not loaded on builder pages).

   Previews come from the h15-card-render Worker: GET /?code=&taxi= (edge-cached plain front), POST front (extra
   frequency), POST cr (checkride front), POST back (brand / cfi / aircraft / lostfound / combo / timeline). Every
   SVG is sanitized and drawn inside the v3 card body with a real open hole; the painted drill mark is dropped.

   A FIELD WE DON'T HAVE (2026-10-21): no add to bag. The button becomes "email us for <CODE>", a mailto with the
   whole card filled in (subject "<CODE> request", which fastmail/sweep.py tags "+"). We draw it,
   reply with the proof, deploy it to the Worker, and they order it here, so the live preview IS the proof.

   A FIELD WE PUBLISH WITH NO FREQUENCIES (2026-10-25): the GET's x-h15-freqs says 0, so a free "frequencies" block
   opens with 4 name + number rows. Names snap to the labels the cards draw ("tower" -> TWR; anything else is refused)
   and numbers to a real VHF channel in the cards' form, by createFreqRules, a VERBATIM copy of the Worker's
   freq-rules.js fed a copy of data/freq-labels.json (test_freq_rules.py keeps all three equal). The preview is POST
   front { xf } and is the proof: the customer ticks that they checked them, and the line carries
   "frequencies: TWR 118.3 · GND 121.9" (order_parse.py -> Studio f1..f4, flagged unverified). A row the Worker says
   crosses the 1/4in keep-out (x-h15-state wide-*) can't go in the bag. The +$3 extra frequency stays for fields
   that have frequencies. */
(function () {
  'use strict';
  var root = document.querySelector('.h15bld');
  if (!root) return;
  var CFG;
  try { CFG = JSON.parse(root.querySelector('.h15bld-cfg').textContent); } catch (e) { return; }
  var KIND = CFG.kind;

  /* ---------- the add-on table (same as addon-widget.js; addon-guard.js reads it on every page) ---------- */
  var ADDON_CFG = {
    'airport-layout-card-any-airport': { addons: ['extra frequency', 'aircraft outline', 'taxiway + apron', 'lost & found back', 'back art + registration', 'training timeline'], ref: { key: 'Airport', label: 'airport', required: true } },
    'checkride-card-custom': { addons: ['taxiway + apron', 'aircraft outline', 'lost & found back', 'training timeline'], ref: { key: 'Airport', label: 'checkride airport', required: true } },
    'custom-card': { addons: ['aircraft outline', 'lost & found back', 'back art + registration', 'training timeline'], ref: { key: 'Details', label: 'card text', required: false } },
    'reference-card': { addons: ['lost & found back'], ref: null },
    'airline-card': { addons: ['second aircraft on the back', 'lost & found back'], ref: { key: 'Airline', label: 'airline', required: true } }
  };
  var CLAIMS = {
    'extra frequency': ['extra freq'], 'aircraft outline': ['aircraft', 'aircraft reg'], 'taxiway + apron': ['taxiway + apron'],
    'lost & found back': ['l&f name', 'l&f address', 'l&f phone', 'l&f email'], 'back art + registration': ['back art', 'back art reg'],
    'training timeline': ['timeline', 'timeline total', 'timeline name'], 'second aircraft on the back': ['back aircraft', 'back airline']
  };
  if (!window.H15_ADDON_CFG) window.H15_ADDON_CFG = ADDON_CFG;
  if (!window.H15_ADDON_CLAIMS) window.H15_ADDON_CLAIMS = CLAIMS;
  if (!KIND) return;

  /* ---------- small tools ---------- */
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function clean(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4); }
  // Shopify hands every price over in the visitor's currency (EUR in France, XOF in Togo ...), so the symbol has to come
  // from Shopify.currency, never a hardcoded "$" (2026-10-23: a Togo visitor read 21,000 XOF as "$21000"). US look unchanged.
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var NF = {};
  function money(c) {
    c = Math.round(c);
    var k = c % 100 ? 2 : 0;
    try {
      if (!NF[k]) NF[k] = new Intl.NumberFormat('en', { style: 'currency', currency: CUR, minimumFractionDigits: k, maximumFractionDigits: k });
      return NF[k].format(c / 100);
    } catch (e) { return (CUR === 'USD' ? '$' : CUR + ' ') + (k ? (c / 100).toFixed(2) : String(c / 100)); }
  }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { if (v) localStorage.setItem(k, v); } catch (e) {} }
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HV = {};
  (CFG.helper || []).forEach(function (v) { HV[v.title] = v; });
  function hp(t) { return HV[t] ? HV[t].price : 0; }
  var ASSET_BASE = String(CFG.assets.ring || '').split('h15-home-ring.webp')[0];
  var CARD_HANDLES = ['airport-layout-card-any-airport', 'checkride-card-custom', 'airline-card', 'reference-card', 'custom-card'];

  /* ---------- typed frequencies on a field we publish without them (the Worker's freq-rules.js, verbatim) ---------- */
  // FREQ-TABLE:BEGIN (data/freq-labels.json without _about; test_freq_rules.py checks it)
  var FREQ_TABLE = {"labels":["ATIS","AWOS","AWIS","AFIS","TWR","GND","CLR","APP","DEP","RADAR","TML","CTR","INFO","CTAF","UNICOM","MULTICOM","MF","ATF","A/G","A/A","RADIO","SAFETYCOM"],
    "aliases":{"atis":"ATIS","datis":"ATIS","awos":"AWOS","asos":"AWOS","aws":"AWOS","awosasos":"AWOS","awos3":"AWOS","awis":"AWIS","awib":"AWIS","autoinfo":"AWIS","afis":"AFIS","twr":"TWR","tower":"TWR","controltower":"TWR","towercontrol":"TWR","tour":"TWR","torre":"TWR","turm":"TWR","gnd":"GND","grnd":"GND","ground":"GND","groundcontrol":"GND","smc":"GND","sol":"GND","clr":"CLR","clearance":"CLR","clearancedelivery":"CLR","delivery":"CLR","del":"CLR","cd":"CLR","clnc":"CLR","clncdel":"CLR","cld":"CLR","preflight":"CLR","app":"APP","appr":"APP","apch":"APP","approach":"APP","approachcontrol":"APP","arrival":"APP","arrivals":"APP","arr":"APP","director":"APP","dep":"DEP","departure":"DEP","departures":"DEP","departurecontrol":"DEP","radar":"RADAR","tml":"TML","terminal":"TML","ctr":"CTR","center":"CTR","centre":"CTR","acc":"CTR","control":"CTR","areacontrol":"CTR","info":"INFO","information":"INFO","fis":"INFO","fic":"INFO","flightinformation":"INFO","ctaf":"CTAF","unicom":"UNICOM","unic":"UNICOM","multicom":"MULTICOM","multi":"MULTICOM","mf":"MF","mandatory":"MF","mandatoryfrequency":"MF","atf":"ATF","aerodrometraffic":"ATF","aerodrometrafficfrequency":"ATF","trafficfrequency":"ATF","ag":"A/G","airground":"A/G","airtoground":"A/G","aa":"A/A","airtoair":"A/A","autoinformation":"A/A","radio":"RADIO","rdo":"RADIO","fss":"RADIO","aas":"RADIO","safetycom":"SAFETYCOM","safety":"SAFETYCOM"},
    "fillers":["freq","frequency","frequencies","mhz"],"band":[118000,136975],"endings":[0,5,10,15,25,30,35,40,50,55,60,65,75,80,85,90],"max_rows":4};
  // FREQ-TABLE:END
  // FREQ-RULES:BEGIN
  function createFreqRules(T) {
    var FILL = {}, END = {};
    T.fillers.forEach(function (w) { FILL[w] = 1; });
    T.endings.forEach(function (e) { END[e] = 1; });
    function words(s) {
      s = String(s == null ? '' : s);
      if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
      return s.toLowerCase().split(/\s+/).map(function (w) { return w.replace(/[^a-z0-9]/g, ''); }).filter(Boolean);
    }
    // the label a typed name engraves as ('' = not one we engrave): the whole name, then without a leading station
    // name ("praha information" -> INFO), then the same without filler words ("tower freq" -> TWR)
    function label(raw) {
      var w = words(raw), sets = [w, w.filter(function (x) { return !FILL[x]; })];
      for (var s = 0; s < sets.length; s++)
        for (var i = 0; i < sets[s].length; i++) {
          var hit = T.aliases[sets[s].slice(i).join('')];
          if (hit) return hit;
        }
      return '';
    }
    // { value: '118.3' } in the cards' own form, or { err: 'empty' | 'format' | 'range' | 'channel' }
    function freq(raw) {
      var s = String(raw == null ? '' : raw).toLowerCase().replace(/\s+/g, '').replace(/mhz$/, '').replace(',', '.');
      if (!s) return { err: 'empty' };
      if (/^1[1-3]\d{2,4}$/.test(s)) s = s.slice(0, 3) + '.' + s.slice(3);      // 1183 -> 118.3, 121775 -> 121.775
      var m = /^(1[1-3]\d)(?:\.(\d{0,3}))?$/.exec(s);
      if (!m) return { err: 'format' };
      var dec = m[2] || '';
      if (dec.length === 2 && (dec.charAt(1) === '2' || dec.charAt(1) === '7')) dec += '5';   // 118.02 = a 25 kHz radio's 118.025
      var khz = +m[1] * 1000 + +(dec + '000').slice(0, 3);
      if (khz < T.band[0] || khz > T.band[1]) return { err: 'range' };
      if (!END[khz % 100]) return { err: 'channel' };
      var f = String(khz % 1000 + 1000).slice(1).replace(/0+$/, '');
      return { value: Math.floor(khz / 1000) + '.' + (f || '0') };
    }
    // up to max_rows typed [name, number] pairs -> { rows: [[LABEL, value], ...], errs: one per pair
    // ('' fine or blank | 'both' | 'label' | a freq err) }. Blank pairs are skipped, so rows close up.
    function rows(pairs) {
      var out = [], errs = [];
      (pairs || []).slice(0, T.max_rows).forEach(function (p) {
        var l = String((p && p[0]) || '').trim(), v = String((p && p[1]) || '').trim();
        if (!l && !v) { errs.push(''); return; }
        if (!l || !v) { errs.push('both'); return; }
        var L = label(l), F = freq(v);
        if (!L) { errs.push('label'); return; }
        if (F.err) { errs.push(F.err); return; }
        errs.push(''); out.push([L, F.value]);
      });
      return { rows: out, errs: errs };
    }
    return { label: label, freq: freq, rows: rows, labels: T.labels.slice() };
  }
  // FREQ-RULES:END
  // what each label is, for the name box's suggestions (the label is what engraves)
  var FQ_NAMES = { ATIS: 'atis', AWOS: 'awos / asos', AWIS: 'awis', AFIS: 'afis', TWR: 'tower', GND: 'ground', CLR: 'clearance delivery',
    APP: 'approach', DEP: 'departure', RADAR: 'radar', TML: 'terminal', CTR: 'center', INFO: 'information', CTAF: 'ctaf', UNICOM: 'unicom',
    MULTICOM: 'multicom', MF: 'mandatory frequency', ATF: 'aerodrome traffic', 'A/G': 'air/ground', 'A/A': 'air to air', RADIO: 'radio', SAFETYCOM: 'safetycom' };
  var FQ = createFreqRules(FREQ_TABLE);

  /* ---------- what each card offers ---------- */
  var FRONTS = { card: ['taxi', 'freq'], checkride: ['taxi'], airline: [], reference: [] }[KIND] || [];
  var FRONT = { taxi: { addon: 'taxiway + apron', name: 'taxiways + apron', sub: 'the whole field, not just the runways' },
                freq: { addon: 'extra frequency', name: 'extra frequency', sub: 'one more line in the frequency block' } };
  FRONTS = FRONTS.filter(function (k) { return HV[FRONT[k].addon]; });
  var BACKS = {
    brand: { name: 'fly more mark', sub: 'on every card', addons: [] },
    cfi:   { name: 'fly more mark + your cfi', sub: 'cfi name and home field', addons: [] },
    ac:    { name: 'aircraft outline', sub: 'your type and tail number', addons: ['aircraft outline'] },
    lf:    { name: 'lost & found', sub: 'how to get it back to you', addons: ['lost & found back'] },
    combo: { name: 'aircraft + lost & found', sub: 'both, one back', addons: ['aircraft outline', 'lost & found back'] },
    art:   { name: 'back art + registration', sub: 'tell us what to draw', addons: ['back art + registration'] },
    tl:    { name: 'training timeline', sub: 'every rating and the date you passed it', addons: ['training timeline'] },
    air2:  { name: 'second aircraft', sub: 'a different jet on the back', addons: ['second aircraft on the back'] }
  };
  var KBACKS = ({ card: ['brand', 'ac', 'lf', 'combo', 'art', 'tl'], checkride: ['cfi', 'ac', 'lf', 'tl'], airline: ['brand', 'air2', 'lf'], reference: ['brand', 'lf'] }[KIND] || ['brand'])
    .filter(function (k) { return BACKS[k].addons.every(function (t) { return HV[t]; }); });
  function backPrice(k) { return BACKS[k].addons.reduce(function (a, t) { return a + hp(t); }, 0); }
  var RATINGS = ['private pilot', 'instrument rating', 'commercial pilot', 'multi-engine', 'CFI', 'CFII', 'MEI', 'ATP', 'other (type it below)'];
  var AC_TYPES = ['cessna 152', 'cessna 172', 'cessna 182', 'piper pa-28', 'piper archer', 'piper seminole', 'cirrus sr20', 'cirrus sr22', 'diamond da20', 'diamond da40', 'diamond da42', 'beechcraft baron', 'robinson r22', 'robinson r44', 'pilatus pc-12 ng', 'boeing 737', 'airbus a320'];
  var AIRKEY = { '737-800': 'b737-800-aal', 'A320-200': 'a320-200-ual', 'A321neo': 'a321neo-ual', '737 MAX 8': 'b737max8-ual', 'A220-300': 'a220-300-asa',
    'E175': 'e175-skw', 'CRJ900': 'crj900-rpa', 'Q400': 'q400-qxe', 'ATR 72-600': 'atr72-nks', '757-200': 'b757-200-fft', '767-300ER': 'b767-300er-skw',
    '777-300ER': 'b777-300er-baw', '787-9': 'b787-9-ual', 'A330-300': 'a330-300-jia', 'A350-900': 'a350-900-sia', '747-400': 'b747-400-edv', 'A380-800': 'a380-800-uae' };
  var REFKEY = { 'fuel reserves': 'fuel-reserves', 'vfr cruising altitudes': 'hemispheric-altitudes', 'common frequencies': 'common-frequencies',
    'emergency squawk': 'squawk-codes', 'arrow': 'arrow', 'imsafe': 'imsafe', 'pave': 'pave' };
  function variantArt(v) {
    if (!v) return '';
    if (KIND === 'airline') { var k = AIRKEY[String(v.title).split(' · ')[0]]; return k ? ASSET_BASE + 'h15-air-' + k + '.webp' : ''; }
    if (KIND === 'reference') { var r = REFKEY[String(v.title).toLowerCase()]; return r ? ASSET_BASE + 'h15-ref-' + r + '.webp' : ''; }
    return '';
  }

  /* ---------- state ---------- */
  var qs = new URLSearchParams(location.search);
  var startVariant = +qs.get('variant') || 0;
  var V = CFG.variants.filter(function (v) { return v.available; });
  if (!V.length) V = CFG.variants;
  var st = {
    code: '', typed: '', name: '', miss: false, checking: false, down: false, taxiOk: true,
    taxi: false, freq: false, freqL: '', freqV: '',
    nf: null, fq: [['', ''], ['', ''], ['', ''], ['', '']], fqT: [0, 0, 0, 0], fqTried: false, fqOk: false, fqState: '', fqDrawn: null,
    back: KBACKS[0], f: {},
    rating: '', crName: '', crDate: '', ride: '',
    variant: (V.filter(function (v) { return v.id === startVariant; })[0] || V[0] || {}).id,
    airline: '', qty: 1, cartCards: 0,
    tl: ['FIRST SOLO', 'PRIVATE', 'INSTRUMENT', 'COMMERCIAL SE', 'COMMERCIAL ME', 'CFI', 'CFII'].map(function (r) { return [r, '']; })
  };
  var DEMO = 'KJFK';
  function field() { return KIND === 'card' || KIND === 'checkride'; }
  function cur() { return st.code || (st.miss ? '' : clean(st.typed)) || DEMO; }
  function asking() { return field() && st.miss && clean(st.typed).length >= 4; }   // a full code the Worker doesn't have
  function variant() { return CFG.variants.filter(function (v) { return v.id === st.variant; })[0] || CFG.variants[0]; }

  /* ---------- the Worker + SVG safety ---------- */
  function wget(path) { return fetch(CFG.endpoint + path, { credentials: 'omit' }); }
  // on the airport GETs: a new URL, so no browser holds a 30-day copy from before x-h15-freqs (the Worker ignores &v=)
  var GV = '&v=fq';
  function wpost(body) { return fetch(CFG.endpoint + '/', { method: 'POST', credentials: 'omit', headers: { 'content-type': 'text/plain' }, body: JSON.stringify(body) }); }
  // keep the Worker's art, drop its background rect + the painted hole (we cut a real one), and anything unsafe
  function cardInner(svg) {
    try {
      var doc = new DOMParser().parseFromString(svg, 'image/svg+xml');
      var s = doc.documentElement;
      if (!s || s.nodeName.toLowerCase() !== 'svg' || doc.querySelector('parsererror')) return '';
      var first = s.querySelector('rect');
      if (first && +first.getAttribute('width') >= 212 && +first.getAttribute('height') >= 336) first.remove();
      [].slice.call(s.querySelectorAll('circle')).forEach(function (c) { if (Math.abs(+c.getAttribute('r') - 7.81) < 0.05 && +c.getAttribute('cy') === 25) c.remove(); });
      [].slice.call(s.querySelectorAll('script, foreignObject, iframe, object, embed, use, a')).forEach(function (n) { n.remove(); });
      [].slice.call(s.querySelectorAll('*')).forEach(function (n) {
        [].slice.call(n.attributes).forEach(function (a) {
          var v = (a.value || '').replace(/[\s\u0000-\u001f]/g, '').toLowerCase();
          if (/^on/i.test(a.name) || v.indexOf('javascript:') === 0 || (/href$/i.test(a.name) && v.indexOf('data:image/') !== 0 && v.charAt(0) !== '#')) n.removeAttribute(a.name);
        });
      });
      var out = new XMLSerializer().serializeToString(s);
      out = out.replace(/^<svg[^>]*>/, '').replace(/<\/svg>\s*$/, '').replace(/<!--[\s\S]*?-->/g, '');
      return out.replace(/fill="#f4f4f4"/gi, 'fill="var(--etch)"').replace(/fill="#e9e9e6"/gi, 'fill="var(--etch)"');
    } catch (e) { return ''; }
  }
  var RING_UNDER = '<image href="' + esc(CFG.assets.ring) + '" x="-53.85" y="214.15" width="111.70" height="111.70" filter="url(#h15b-ring-sh)"/>' +
    '<g clip-path="url(#h15b-rc)"><rect width="212.5" height="337" rx="12.5" fill="#000" opacity=".6" filter="url(#h15b-ring-cast)"/></g>';
  function cardBody(inner, back, ring) {
    return '<svg class="b-card" viewBox="0 0 212.5 337" aria-hidden="true">' + (ring ? RING_UNDER : '') + '<g mask="url(#' + (back ? 'h15b-hole-b' : 'h15b-hole') + ')">' +
      '<rect width="212.5" height="337" rx="12.5" fill="var(--metal)"/><rect width="212.5" height="337" rx="12.5" fill="url(#h15b-light)"/>' +
      '<g fill="var(--etch)" font-family="Montserrat, sans-serif">' + inner + '</g>' +
      '<rect width="212.5" height="337" rx="12.5" fill="#fff" filter="url(#h15b-grain)" opacity=".05"/>' +
      '<rect x=".6" y=".6" width="211.3" height="335.8" rx="11.9" fill="none" stroke="url(#h15b-edge)" stroke-width="1.2"/></g></svg>';
  }
  function imgCard(src, ring) {
    return '<svg class="b-card" viewBox="0 0 212.5 337" aria-hidden="true">' + (ring ? RING_UNDER : '') + (src ? '<image href="' + esc(src) + '" width="212.5" height="337" preserveAspectRatio="none"/>' : '') + '</svg>';
  }

  /* ---------- the options (built once; toggles show/hide, typing never rebuilds an input) ---------- */
  var O = $('#h15b-opts');
  function opt(attr, on, nm, sub, pr, box) {
    return '<button type="button" class="b-opt' + (box ? ' b-box' : '') + '" role="' + (box ? 'checkbox' : 'radio') + '" ' + attr + ' aria-checked="' + on + '"><span class="b-dot"></span><span class="b-nm">' + nm + (sub ? '<small>' + sub + '</small>' : '') + '</span><span class="b-pr">' + pr + '</span></button>';
  }
  function inp(key, ph, extra) { return '<input class="b-in" data-f="' + key + '" placeholder="' + esc(ph) + '"' + (extra || '') + '>'; }
  function backFields(k) {
    var h = '';
    if (k === 'cfi') h = '<div class="b-two">' + inp('cfi', 'cfi name') + inp('home', 'home field') + '</div>';
    if (k === 'ac' || k === 'combo') h += '<div class="b-two">' + inp('acType', 'aircraft · cessna 172', ' list="h15b-actypes"') + inp('acReg', 'tail · N1500H') + '</div>';
    if (k === 'lf' || k === 'combo') h += inp('lfName', 'name') + inp('lfA1', 'address') + inp('lfA2', 'city, state, zip') + '<div class="b-two">' + inp('lfPhone', 'phone') + inp('lfEmail', 'email') + '</div><span class="b-small">share only what you want. one line is enough.</span>';
    if (k === 'art') h = '<textarea class="b-in" data-f="artDesc" rows="2" placeholder="what to engrave on the back"></textarea>' + inp('artReg', 'registration (optional)') + '<span class="b-small">we draw it and send a proof before it’s engraved.</span>';
    if (k === 'tl') h = '<div style="display:grid;gap:6px">' + st.tl.map(function (r, i) { return '<div class="b-two"><input class="b-in" data-tl="' + i + '" data-tlk="0" value="' + esc(r[0].toLowerCase()) + '" aria-label="rating"><input class="b-in" data-tl="' + i + '" data-tlk="1" placeholder="date passed" aria-label="date passed"></div>'; }).join('') + '</div>' +
      inp('tlTotal', 'total, start to finish (optional)') + inp('tlName', 'name on the back (optional)') + '<span class="b-small">only rows with a date are engraved.</span>';
    if (k === 'air2') h = '<select class="b-in" data-f="air2">' + CFG.variants.map(function (v) { return '<option>' + esc(v.title) + '</option>'; }).join('') + '</select>' + inp('air2l', 'airline on the back · same as the front', ' list="h15b-airlines"');
    return h ? '<div class="b-subf" data-sub="' + k + '" hidden>' + h + '</div>' : '';
  }
  function buildOpts() {
    var h = '';
    if (field()) h += '<div class="b-sec"><span class="b-lbl">' + (KIND === 'checkride' ? 'checkride airport' : 'your airport') + '</span>' +
      '<label class="b-field"><input id="h15b-ap" maxlength="4" placeholder="' + DEMO + '" autocomplete="off" autocapitalize="characters" spellcheck="false" enterkeyhint="done" aria-label="airport code" aria-describedby="h15b-st"><span class="b-st" id="h15b-st" aria-live="polite">type your field</span></label>' +
      '<div class="b-askt" id="h15b-askt" hidden></div></div>';
    if (KIND === 'card') h += '<div class="b-sec" id="h15b-fq" hidden><span class="b-lbl"><span>frequencies</span><span>free</span></span>' +
      '<span class="b-small" id="h15b-fqtop"></span>' +
      [0, 1, 2, 3].map(function (i) {
        return '<div class="b-fqr"><div class="b-two"><input class="b-in" data-fq="' + i + '" data-fk="0" placeholder="' + ['name · tower', 'name · ground', 'name', 'name'][i] + '" maxlength="24" list="h15b-fqlabels" autocomplete="off" spellcheck="false" aria-label="frequency ' + (i + 1) + ' name">' +
          '<input class="b-in" data-fq="' + i + '" data-fk="1" placeholder="' + ['118.3', '121.9', '', ''][i] + '" maxlength="12" inputmode="decimal" autocomplete="off" aria-label="frequency ' + (i + 1) + ' number"></div>' +
          '<span class="b-fqh" data-fqh="' + i + '" aria-live="polite"></span></div>';
      }).join('') +
      '<span class="b-small">1 and 2 sit side by side on the top row, 3 and 4 below. names we engrave: ' + FQ.labels.join(' · ') + '</span>' +
      '<span class="b-fqmsg" id="h15b-fqmsg" aria-live="polite"></span>' +
      opt('data-fqok', false, 'i checked these frequencies', 'we engrave them exactly as the card shows. we don’t verify them.', '', true) +
      '<datalist id="h15b-fqlabels">' + FQ.labels.map(function (l) { return '<option value="' + esc(l) + '" label="' + esc(FQ_NAMES[l] || '') + '">'; }).join('') + '</datalist></div>';
    if (KIND === 'checkride') h += '<div class="b-sec"><span class="b-lbl">the checkride</span><select class="b-in" data-s="rating" aria-label="rating"><option value="">rating</option>' +
      RATINGS.map(function (r) { return '<option value="' + esc(r) + '">' + esc(r.toLowerCase()) + '</option>'; }).join('') + '</select>' +
      '<div class="b-two"><input class="b-in" data-s="crName" placeholder="name on the card" aria-label="name on the card"><input class="b-in" data-s="crDate" placeholder="date passed" aria-label="date passed"></div>' +
      '<input class="b-in" data-s="ride" placeholder="your exact ride (optional)" aria-label="your exact ride"></div>';
    if (KIND === 'airline') h += '<div class="b-sec"><span class="b-lbl">aircraft</span><select class="b-in" data-s="variant" aria-label="aircraft">' +
      CFG.variants.map(function (v) { return '<option value="' + v.id + '"' + (v.id === st.variant ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + '</option>'; }).join('') + '</select>' +
      '<span class="b-lbl">airline</span><input class="b-in" data-s="airline" list="h15b-airlines" placeholder="type your airline" autocomplete="off" aria-label="airline"><div class="b-engr" id="h15b-engr"></div></div>';
    if (KIND === 'reference') h += '<div class="b-sec"><span class="b-lbl">design</span><div class="b-picks" role="radiogroup" aria-label="design">' +
      CFG.variants.map(function (v) { return '<button type="button" class="b-pick" role="radio" data-v="' + v.id + '" aria-checked="' + (v.id === st.variant) + '"' + (v.available ? '' : ' disabled') + '><img alt="" src="' + esc(variantArt(v)) + '"><span>' + esc(v.title.toLowerCase()) + '</span></button>'; }).join('') + '</div></div>';
    if (FRONTS.length) h += '<div class="b-sec"><span class="b-lbl">front</span>' + FRONTS.map(function (k) {
      return opt('data-front="' + k + '"', false, FRONT[k].name, FRONT[k].sub, '+' + money(hp(FRONT[k].addon)), true) +
        (k === 'freq' ? '<div class="b-subf" data-sub="freq" hidden><div class="b-two"><input class="b-in" data-s="freqL" placeholder="label · UNICOM" maxlength="10"><input class="b-in" data-s="freqV" placeholder="122.80" maxlength="12"></div></div>' : '');
    }).join('') + '</div>';
    if (KBACKS.length) h += '<div class="b-sec"><span class="b-lbl">back</span><div role="radiogroup" aria-label="back of the card" style="display:grid;gap:8px">' + KBACKS.map(function (k) {
      var p = backPrice(k);
      return opt('data-back="' + k + '"', st.back === k, BACKS[k].name, BACKS[k].sub, p ? '+' + money(p) : 'free', false) + backFields(k);
    }).join('') + '</div></div>';
    h += '<div class="b-sec"><span class="b-lbl"><span>quantity</span><span id="h15b-tierlbl"></span></span><div class="b-qty"><button type="button" data-q="-1" aria-label="fewer">−</button><output id="h15b-qty">1</output><button type="button" data-q="1" aria-label="more">+</button></div>' +
      '<div class="b-tiers" id="h15b-tiers">' + [[10, 25], [20, 35], [50, 40]].map(function (t) { return '<span class="b-tier" data-t="' + t[0] + '">' + t[0] + '+ · ' + t[1] + '% off</span>'; }).join('') + '</div><div class="b-sum" id="h15b-sum"></div></div>';
    h += '<datalist id="h15b-actypes">' + AC_TYPES.map(function (a) { return '<option value="' + a + '">'; }).join('') + '</datalist>';
    if (KIND === 'airline') h += '<datalist id="h15b-airlines">' + (window.H15_AIRLINES || []).map(function (a) { return '<option value="' + esc(a.n.toLowerCase()) + '">'; }).join('') + '</datalist>';
    O.innerHTML = h;
    var sub = $('[data-sub="' + st.back + '"]'); if (sub) sub.hidden = false;
  }

  /* ---------- airline lookup (same rules as airline-picker.js) ---------- */
  function norm(s) { return (s || '').toString().trim().toUpperCase().replace(/\s+/g, ' '); }
  function airline(v) {
    var A = window.H15_AIRLINES || [], q = norm(v);
    if (!q) return null;
    for (var i = 0; i < A.length; i++) if (norm(A[i].n) === q || norm(A[i].i) === q || norm(A[i].c) === q) return A[i];
    if (q.length < 3) return null;
    var all = A.filter(function (a) { return norm(a.n).indexOf(q) > -1 || norm(a.i) === q || norm(a.c).indexOf(q) > -1; });
    return all.length === 1 ? all[0] : null;
  }
  function describe(v) { var a = airline(v); return a ? [a.n, a.i, a.c].join(' · ') : norm(v); }

  /* ---------- the stage ---------- */
  var PV = $('#h15b-pv'), CAP = $('#h15b-cap');
  PV.innerHTML = '<div class="b-face"><span class="b-lbl">front</span><div data-face="front"></div></div><div class="b-face"><span class="b-lbl">back</span><div data-face="back"></div></div>';
  var FF = $('[data-face="front"]'), FB = $('[data-face="back"]');
  function put(slot, html) {
    var wrap = document.createElement('div'); wrap.innerHTML = html;
    var n = wrap.firstElementChild; if (!n) return;
    slot.parentNode.replaceChild(n, slot); n.setAttribute('data-face', slot.getAttribute('data-face'));
    if (slot === FF) FF = n; else FB = n;
  }
  // blank card bodies hold the stage while the first art loads
  put(FF, field() ? cardBody('', false, true) : imgCard('', true)); FF.classList.add('b-wait');
  put(FB, cardBody('', true, false)); FB.classList.add('b-wait');
  var fSeq = 0, bSeq = 0, fTimer = 0, bTimer = 0, frontCache = {}, backCache = {}, fqStates = {};
  function crRating() { return /^other\b/i.test(st.rating) ? st.ride : st.rating; }
  function frontReq() {
    var code = cur();
    if (KIND === 'card') {
      if (fqOn()) { var fr = fqRes().rows; if (fr.length) return { post: { m: 'front', code: code, taxi: st.taxi ? 1 : 0, xf: fr }, fq: fqKey(fr) }; }
      if (st.freq && (st.freqL || st.freqV)) return { post: { m: 'front', code: code, taxi: st.taxi ? 1 : 0, xfl: st.freqL, xfv: st.freqV } };
      return { get: '/?code=' + encodeURIComponent(code) + (st.taxi ? '&taxi=1' : '') + GV };
    }
    return { post: { m: 'cr', code: code, rating: crRating() || 'your rating', name: st.crName || 'name on the card', date: st.crDate || 'date passed' } };
  }
  function paintFront() {
    if (KIND === 'airline' || KIND === 'reference') { put(FF, imgCard(variantArt(variant()), true)); return; }
    clearTimeout(fTimer);
    fTimer = setTimeout(function () {
      var r = frontReq(), key = JSON.stringify(r), my = ++fSeq;
      if (frontCache[key]) { put(FF, cardBody(frontCache[key], false, true)); if (r.fq) fqDrawn(r.fq, fqStates[key]); return; }
      if (FF.classList) FF.classList.add('b-wait');
      (r.get ? wget(r.get) : wpost(r.post)).then(function (res) {
        if (my !== fSeq) return;
        if (res.status === 404) { if (FF.classList) FF.classList.remove('b-wait'); return; }
        if (!res.ok) throw new Error('front ' + res.status);
        if (r.get) st.taxiOk = res.headers.get('x-h15-taxi') !== '0';
        // typed rows: the Worker's own reading of them must be ours, or the bag would carry a card the preview isn't
        var fs = r.fq ? (decodeURIComponent(res.headers.get('x-h15-xf') || '') === fqText(JSON.parse(r.fq)) ? res.headers.get('x-h15-state') || '' : 'bad') : '';
        return res.text().then(function (svg) {
          if (my !== fSeq) return;
          var inner = cardInner(svg); if (!inner) return;
          frontCache[key] = inner; put(FF, cardBody(inner, false, true));
          if (r.fq) { fqStates[key] = fs; fqDrawn(r.fq, fs); }
        });
      }).catch(function () { if (FF.classList) FF.classList.remove('b-wait'); });
    }, r0());
  }
  function r0() { return FF && FF.tagName && FF.tagName.toLowerCase() === 'svg' ? 260 : 0; }
  function backReq() {
    var f = st.f, k = st.back;
    if (k === 'cfi') return { m: 'back', kind: 'brand', placeholder: true, cfi: f.cfi || '', home: f.home || '' };
    if (k === 'ac') return { m: 'back', kind: 'aircraft', aircraft: f.acType || '', aircraft_reg: f.acReg || '' };
    if (k === 'lf') return { m: 'back', kind: 'lostfound', lf_name: f.lfName || '', lf_addr1: f.lfA1 || '', lf_addr2: f.lfA2 || '', lf_phone: f.lfPhone || '', lf_email: f.lfEmail || '' };
    if (k === 'combo') return { m: 'back', kind: 'combo', aircraft: f.acType || '', aircraft_reg: f.acReg || '', lf_name: f.lfName || '', lf_addr1: f.lfA1 || '', lf_addr2: f.lfA2 || '', lf_phone: f.lfPhone || '', lf_email: f.lfEmail || '' };
    if (k === 'tl') return { m: 'back', kind: 'timeline', tl_rows: tlRows(), tl_total: f.tlTotal || '', tl_name: f.tlName || '' };
    return { m: 'back', kind: 'brand', placeholder: false };
  }
  var backNote = '';
  function paintBack() {
    if (st.back === 'air2') { put(FB, imgCard(ASSET_BASE + 'h15-air-back.webp', false)); backNote = 'sample shows the layout. your second aircraft engraves in its place.'; caption(); return; }
    clearTimeout(bTimer);
    bTimer = setTimeout(function () {
      var body = backReq(), key = JSON.stringify(body), my = ++bSeq;
      backNote = st.back === 'art' ? 'we draw what you describe. you get a proof by email before anything is engraved.' : '';
      if (backCache[key]) { put(FB, cardBody(backCache[key].inner, true, false)); noteFor(backCache[key].state); return; }
      if (FB.classList) FB.classList.add('b-wait');
      wpost(body).then(function (res) {
        if (my !== bSeq || !res.ok) { if (FB.classList) FB.classList.remove('b-wait'); return; }
        var stt = res.headers.get('x-h15-state') || '';
        return res.text().then(function (svg) {
          if (my !== bSeq) return;
          var inner = cardInner(svg); if (!inner) return;
          backCache[key] = { inner: inner, state: stt };
          put(FB, cardBody(inner, true, false)); noteFor(stt);
        });
      }).catch(function () { if (FB.classList) FB.classList.remove('b-wait'); });
    }, FB && FB.tagName && FB.tagName.toLowerCase() === 'svg' ? 280 : 0);
  }
  function noteFor(stt) {
    if (st.back === 'ac' || st.back === 'combo') {
      if (stt === 'unknown') backNote = 'we don’t have that type drawn yet. we draw it to order and email you a proof first.';
      else if (stt === 'empty') backNote = 'type your aircraft to see it on the back.';
    }
    caption();
  }
  function caption() {
    var c = '';
    if (field()) c = st.code ? st.code + (st.name ? ' · ' + st.name : '') : asking() ? 'example card · we’ll draw ' + clean(st.typed) + ' and email you a proof' : st.down ? clean(st.typed) : 'example · type your field';
    if (KIND === 'checkride' && st.taxi) c += (c ? ' · ' : '') + 'taxiways + apron are added on your proof';
    if (KIND === 'card' && st.taxi && !st.taxiOk) c += (c ? ' · ' : '') + 'we draw the taxiways to order for this field';
    if (KIND === 'airline') c = 'sample shows the layout. your airline engraves in its place.';
    if (backNote) c = backNote;
    CAP.textContent = c;
  }

  /* ---------- typed frequencies (a field with none on file: x-h15-freqs 0) ---------- */
  function fqOn() { return KIND === 'card' && !!st.code && st.nf === 0; }
  function fqRes() { return FQ.rows(st.fq); }
  function fqKey(rows) { return JSON.stringify(rows); }
  function fqText(rows) { return rows.map(function (r) { return r.join(' '); }).join(' · '); }
  function fqDrawn(k, state) { st.fqDrawn = k; st.fqState = state || ''; fqMsg(); }
  var FQ_ERR = { both: 'add a name and a number.', label: 'not a name we engrave. pick one from the list, like TWR, GND, CTAF or RADIO.',
    format: 'type the number like 118.3.', range: 'airband frequencies run 118.000 to 136.975.', channel: 'that isn’t a radio channel. check the last digits.' };
  // a row's line under it: what engraves, or (once they've left the box, or tried to add) what's wrong
  function fqHint(i) {
    var el = $('[data-fqh="' + i + '"]'); if (!el) return;
    var l = st.fq[i][0].trim(), v = st.fq[i][1].trim(), L = l ? FQ.label(l) : '', F = v ? FQ.freq(v) : {};
    var t = st.fqT[i] | (st.fqTried ? 3 : 0), badL = !!(l && !L && t & 1), badV = !!(v && F.err && t & 2), both = st.fqTried && !l !== !v;
    el.className = 'b-fqh' + (badL || badV || both ? ' b-bad' : L && F.value ? ' b-ok' : '');
    el.textContent = badL ? FQ_ERR.label : badV ? FQ_ERR[F.err] : both ? FQ_ERR.both : L ? 'engraves as ' + L + (F.value ? ' ' + F.value : '') : '';
    $$('[data-fq="' + i + '"]').forEach(function (inp) {
      var bad = inp.getAttribute('data-fk') === '0' ? badL || (both && !l) : badV || (both && !v);
      inp.classList.toggle('b-bad', bad); inp.setAttribute('aria-invalid', String(bad));
    });
  }
  function fqMsg() {
    var m = $('#h15b-fqmsg'); if (!m) return;
    var rows = fqRes().rows, w = st.fqDrawn === fqKey(rows) ? /^wide-(top|bottom)$/.exec(st.fqState) : null;
    if (!w) { m.textContent = ''; return; }
    var pair = w[1] === 'top' ? rows.slice(0, 2) : rows.slice(2);
    m.textContent = pair.map(function (r) { return r.join(' '); }).join(' and ') + ' are too wide to sit side by side on the card. use a shorter name' +
      (rows.length > 2 ? ', or change the order so they land on different rows.' : '.');
  }
  // show the block on a freq-less field (and retire the +$3 extra frequency there: these rows replace it)
  function paintFq() {
    var sec = $('#h15b-fq'); if (!sec) return;
    var on = fqOn(), xb = $('[data-front="freq"]');
    sec.hidden = !on;
    if (xb) {
      xb.hidden = on;
      if (on && st.freq) { st.freq = false; xb.setAttribute('aria-checked', 'false'); var sf = $('[data-sub="freq"]'); if (sf) sf.hidden = true; }
    }
    if (!on) return;
    $('#h15b-fqtop').textContent = 'we don’t have frequencies on file for ' + st.code + '. add up to 4 you use and they engrave on the front.';
    [0, 1, 2, 3].forEach(fqHint);
    $('[data-fqok]').setAttribute('aria-checked', String(st.fqOk));
    fqMsg();
  }
  function tlRows() { return st.tl.filter(function (r) { return r[0].trim() && r[1].trim(); }).map(function (r) { return r[0].trim().toUpperCase() + ' | ' + r[1].trim(); }).join(' ; '); }

  /* ---------- the airport field ---------- */
  var lookSeq = 0, lookTimer = 0;
  function setStatus(cls, html) { var e = $('#h15b-st'); if (!e) return; e.className = 'b-st' + (cls ? ' b-' + cls : ''); e.innerHTML = html; }
  function lookup(v) {
    var my = ++lookSeq;
    st.checking = true;
    wget('/?code=' + encodeURIComponent(v) + GV).then(function (res) {
      if (my !== lookSeq) return;
      st.checking = false; st.down = false;
      var nf = res.headers.get('x-h15-freqs');
      st.nf = nf === null || nf === '' || isNaN(+nf) ? null : +nf;   // null (an older Worker): no typed-freq block
      if (res.status === 404) {
        st.code = ''; st.miss = v.length >= 3;
        setStatus(v.length >= 4 ? 'miss' : '', v.length >= 4 ? 'we don’t have ' + esc(v) + ' yet. we’ll draw it and email you a proof first.' : 'keep typing…');
        afterCode(); return;
      }
      if (!res.ok) throw new Error('lookup ' + res.status);
      st.code = (res.headers.get('x-h15-disp') || v).toUpperCase(); st.miss = false; st.taxiOk = res.headers.get('x-h15-taxi') !== '0';
      setStatus('ok', esc(st.code)); lsSet('h15.airport', st.code);
      wget('/?m=hat&code=' + encodeURIComponent(st.code)).then(function (h) {
        if (!h.ok) return;
        try { st.name = decodeURIComponent(h.headers.get('x-h15-name') || '').toLowerCase(); } catch (e) {}
        if (my === lookSeq && st.name) { setStatus('ok', esc(st.code) + ' · ' + esc(st.name)); caption(); }
        return h.text().then(function (t) { hatInk[st.code] = safeArt(t); paintRest(); });
      }).catch(function () {});
      afterCode();
    }).catch(function () { if (my === lookSeq) { setStatus('', 'can’t check that right now. you can still order it.'); st.code = ''; st.miss = false; st.checking = false; st.down = true; st.nf = null; afterCode(); } });
  }
  function afterCode() { paintFq(); paintFront(); paintPrice(); caption(); paintTabs(); paintRest(); paintBuy(); }
  function onAirport(input) {
    var v = clean(input.value); if (input.value !== v) input.value = v;
    st.typed = v; st.code = ''; st.miss = false; st.name = ''; st.down = false; st.checking = v.length >= 3;
    st.nf = null; st.fqOk = false; st.fqTried = false;   // another field: its frequencies get ticked again
    paintFq();
    clearTimeout(lookTimer);
    if (!v) { setStatus('', 'type your field'); afterCode(); return; }
    if (v.length < 3) { setStatus('', 'keep typing…'); paintBuy(); return; }
    lookTimer = setTimeout(function () { lookup(v); }, 280);
  }
  function paintTabs() {
    var c = st.code || '';
    $$('.b-kinds a[data-tab]').forEach(function (a) {
      var base = CFG.urls[a.getAttribute('data-tab')]; if (!base) return;
      var fieldTab = a.getAttribute('data-tab') === 'card' || a.getAttribute('data-tab') === 'checkride';
      a.setAttribute('href', base + (c && fieldTab ? '?airport=' + encodeURIComponent(c) : ''));
    });
  }

  /* ---------- price, quantity, summary ---------- */
  function addons() {
    var t = [];
    FRONTS.forEach(function (k) { if (st[k]) t.push(FRONT[k].addon); });
    BACKS[st.back].addons.forEach(function (a) { t.push(a); });
    return t;
  }
  function unit() { return (variant() || { price: 0 }).price + addons().reduce(function (a, t) { return a + hp(t); }, 0); }
  function paintPrice() {
    var u = unit(), q = st.qty, cards = st.cartCards + q;
    $('#h15b-price').textContent = money(u);
    $('#h15b-qty').textContent = q;
    var tier = [[10, 25], [20, 35], [50, 40]].filter(function (x) { return cards >= x[0]; }).pop();
    $$('#h15b-tiers .b-tier').forEach(function (el) { el.classList.toggle('b-on', !!tier && +el.getAttribute('data-t') === tier[0]); });
    var next = [[10, 25], [20, 35], [50, 40]].filter(function (x) { return cards < x[0]; })[0];
    $('#h15b-tierlbl').innerHTML = tier ? '<a href="' + quoteMail(cards) + '">email us for the ' + tier[1] + '% quote →</a>' : (next && cards >= 5 ? (next[0] - cards) + ' more for ' + next[1] + '% off by quote' : '');
    var rows = '<div class="b-row"><span>' + q + ' × ' + money(u) + '</span><span>' + money(u * q) + '</span></div>' +
      '<div class="b-row"><span>gunmetal o-ring' + (q > 1 ? ', one per card' : '') + '</span><span>included</span></div>';
    var left = 3 - cards;
    rows += '<div class="b-row"><span>' + (CFG.country === 'US' ? 'free us shipping' : left > 0 ? left + ' more card' + (left > 1 ? 's' : '') + ' and shipping is free, worldwide' : 'free worldwide shipping') + '</span><span></span></div>';
    rows += '<div class="b-row b-t"><span>total</span><span>' + money(u * q) + '</span></div>';
    $('#h15b-sum').innerHTML = rows;
    var btn = $('#h15b-add');
    if (btn && !btn.disabled) btn.textContent = 'add ' + (field() && st.code ? st.code + ' ' : '') + 'to bag · ' + money(u * q);
  }
  function quoteMail(n) {
    var body = 'hi,\n\nwe’d like to order cards for our school.\n\nschool or club:\nhome airport: ' + (st.code || (asking() ? clean(st.typed) : '')) + '\nhow many cards: ' + n + '\nwhat goes on the back:\nwho to invoice:';
    return 'mailto:' + CFG.email + '?subject=' + encodeURIComponent('School / club order') + '&body=' + encodeURIComponent(body);
  }

  /* ---------- a field we don't have yet: email it to us with the card filled in (proof first, then the order) ---------- */
  function askMail() {
    var code = clean(st.typed), f = st.f, p = cardProps(), L = [];
    var card = KIND === 'checkride' ? 'checkride card' : 'airport card';
    function line(k, v) { v = String(v == null ? '' : v).trim(); if (v) L.push(k + ': ' + v); }
    line('card', card);
    line(KIND === 'checkride' ? 'checkride airport' : 'airport', code);
    if (KIND === 'checkride') {
      line('rating', crRating()); line('name on the card', st.crName); line('date passed', st.crDate);
      if (!/^other\b/i.test(st.rating)) line('exact ride', st.ride);
    }
    line('front', FRONTS.filter(function (k) { return st[k]; }).map(function (k) { return FRONT[k].name; }).join(', '));
    line('extra freq', p['extra freq']);
    line('back', BACKS[st.back].name);
    if (st.back === 'cfi') { line('cfi', f.cfi); line('home field', (f.home || '').toUpperCase()); }
    ['aircraft', 'aircraft reg', 'l&f name', 'l&f address', 'l&f phone', 'l&f email', 'back art', 'back art reg', 'timeline', 'timeline total', 'timeline name']
      .forEach(function (k) { line(k, p[k]); });
    line('quantity', st.qty);
    var body = 'hi,\n\nyou don\'t have ' + code + ' yet. could you draw it and send me a proof? i\'ll order once it looks right.\n\n' +
      L.join('\n') + '\n\nanything else, like the frequencies you want on it:\n\n';
    return 'mailto:' + CFG.email + '?subject=' + encodeURIComponent(code + ' request') + '&body=' + encodeURIComponent(body);
  }
  var BUY = $('#h15b-buy'), ASK = null;
  if (BUY && field()) {
    ASK = document.createElement('div'); ASK.hidden = true; ASK.className = 'b-askt';
    var addEl = $('#h15b-add');
    BUY.insertBefore(ASK, addEl ? addEl.nextSibling : null);
  }
  function paintBuy() {
    if (!ASK) return;
    var on = asking(), btn = $('#h15b-add'), top = $('#h15b-askt');
    if (btn) btn.hidden = on;
    ASK.hidden = !on; if (top) top.hidden = !on;
    if (!on) return;
    clearErr(); var d = $('#h15b-done'); if (d) d.hidden = true;
    var code = esc(clean(st.typed)), href = esc(askMail());
    // under the airport box: one tap. at the bottom (where add to bag was): the same, with the options they picked
    if (top) top.innerHTML = '<a class="b-btn" data-ask href="' + href + '">email us for ' + code + '</a>' +
      '<span class="b-small">it opens your email, ready to send. you only order once the proof looks right.</span>';
    ASK.innerHTML = '<a class="b-btn" data-ask href="' + href + '">email us for ' + code + '</a>' +
      '<span class="b-small">it opens your email with your card filled in. we draw ' + code + ' and send you a proof. you order once it looks right. no email app? write to <a data-ask href="' + href + '">' + esc(CFG.email) + '</a>.</span>';
  }
  // every "email us" link rebuilds its mailto on the click, so it carries whatever they picked after the miss
  root.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('[data-ask]'); if (a) a.setAttribute('href', askMail()); });

  /* ---------- events ---------- */
  O.addEventListener('input', function (e) {
    var t = e.target;
    if (t.id === 'h15b-ap') { onAirport(t); return; }
    if (t.hasAttribute('data-fq')) { var fi = +t.getAttribute('data-fq'); st.fq[fi][+t.getAttribute('data-fk')] = t.value; fqHint(fi); fqMsg(); paintFront(); clearErr(); return; }
    if (t.hasAttribute('data-s')) {
      var k = t.getAttribute('data-s');
      if (k === 'variant') st.variant = +t.value; else st[k] = t.value;
      if (k === 'airline') { var a = airline(t.value), en = $('#h15b-engr'); if (en) en.textContent = a ? 'engraves: ' + [a.n, a.i, a.c].join(' · ') : (t.value ? 'any airline works. we set it from what you type.' : ''); }
      if (k === 'freqL' || k === 'freqV' || KIND === 'checkride') paintFront();
      if (k === 'ride' && /^other\b/i.test(st.rating)) paintFront();
      if (k === 'variant') { paintFront(); paintPrice(); }
      clearErr(); return;
    }
    if (t.hasAttribute('data-f')) { st.f[t.getAttribute('data-f')] = t.value; paintBack(); clearErr(); return; }
    if (t.hasAttribute('data-tl')) { st.tl[+t.getAttribute('data-tl')][+t.getAttribute('data-tlk')] = t.value; paintBack(); clearErr(); }
  });
  O.addEventListener('change', function (e) {
    var t = e.target;
    if (t.getAttribute('data-s') === 'rating') { st.rating = t.value; paintFront(); clearErr(); }
    if (t.getAttribute('data-s') === 'variant') { st.variant = +t.value; paintFront(); paintPrice(); }
    if (t.getAttribute('data-f') === 'air2') { st.f.air2 = t.value; }
  });
  O.addEventListener('focusout', function (e) {   // BJC -> KBJC once the Worker said so
    var t = e.target;
    if (t.id === 'h15b-ap' && st.code && clean(t.value) !== st.code) t.value = st.code;
    if (t.hasAttribute && t.hasAttribute('data-fq')) {   // snap the box to what engraves: tower -> TWR, 118,30 -> 118.3
      var i = +t.getAttribute('data-fq'), k = +t.getAttribute('data-fk'), v = t.value.trim();
      var snap = !v ? '' : k ? FQ.freq(v).value : FQ.label(v);
      if (snap && snap !== t.value) { t.value = snap; st.fq[i][k] = snap; }
      st.fqT[i] |= k ? 2 : 1; fqHint(i);
    }
  });
  O.addEventListener('keydown', function (e) { if (e.target.id === 'h15b-ap' && e.key === 'Enter') { e.preventDefault(); e.target.blur(); } });
  O.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-fqok]'))) { st.fqOk = !st.fqOk; t.setAttribute('aria-checked', String(st.fqOk)); clearErr(); return; }
    if ((t = e.target.closest('[data-front]'))) {
      var k = t.getAttribute('data-front'); st[k] = !st[k]; t.setAttribute('aria-checked', String(st[k]));
      var sf = $('[data-sub="' + k + '"]'); if (sf) sf.hidden = !st[k];
      paintFront(); paintPrice(); caption(); clearErr(); return;
    }
    if ((t = e.target.closest('[data-back]'))) {
      st.back = t.getAttribute('data-back');
      $$('[data-back]').forEach(function (x) { x.setAttribute('aria-checked', String(x === t)); });
      $$('#h15b-opts [data-sub]').forEach(function (s) { if (s.getAttribute('data-sub') !== 'freq') s.hidden = s.getAttribute('data-sub') !== st.back; });
      backNote = ''; paintBack(); paintPrice(); caption(); clearErr(); return;
    }
    if ((t = e.target.closest('[data-v]'))) {
      st.variant = +t.getAttribute('data-v');
      $$('[data-v]').forEach(function (x) { x.setAttribute('aria-checked', String(x === t)); });
      paintFront(); paintPrice(); return;
    }
    if ((t = e.target.closest('[data-q]'))) { st.qty = Math.max(1, Math.min(99, st.qty + +t.getAttribute('data-q'))); paintPrice(); }
  });

  /* ---------- validation + the ONE cart write (addon-widget.js atomicAdd, same shape) ---------- */
  function err(m, html) { var e = $('#h15b-err'); if (e) e[html ? 'innerHTML' : 'textContent'] = m; return false; }
  function clearErr() { var e = $('#h15b-err'); if (e) e.textContent = ''; }
  function validate() {
    var f = st.f;
    if (field() && !(st.code || clean(st.typed))) return err('type your ' + (KIND === 'checkride' ? 'checkride airport' : 'airport') + ' first.');
    // only a field the Worker confirmed goes in the bag (a Worker outage still lets the typed code through)
    if (field() && !st.code && !st.down) {
      var c = clean(st.typed);
      if (st.checking) return err('one sec, still checking ' + c + '.');
      if (c.length < 3) return err('type your full airport code.');
      return err('we don’t have ' + esc(c) + '. type the 4-letter code, or <a data-ask href="' + esc(askMail()) + '">email us</a> and we’ll draw it.', true);
    }
    if (KIND === 'checkride') {
      if (!st.rating) return err('pick the rating you passed.');
      if (/^other\b/i.test(st.rating) && !st.ride.trim()) return err('type your exact ride in the box under the rating.');
      if (!st.crName.trim()) return err('add the name on the card.');
      if (!st.crDate.trim()) return err('add the date you passed.');
    }
    if (KIND === 'airline' && !st.airline.trim()) return err('type your airline.');
    if (st.freq && !(st.freqL || st.freqV)) return err('add the extra frequency (label and number).');
    if (fqOn()) {
      var fr = fqRes(), bad = fr.errs.filter(Boolean)[0];
      if (bad) { st.fqTried = true; paintFq(); return err('check your frequencies: ' + FQ_ERR[bad]); }
      if (fr.rows.length) {
        if (!st.fqOk) return err('tick “i checked these frequencies” to add them to the card.');
        if (st.fqDrawn !== fqKey(fr.rows)) { paintFront(); return err('one sec, the card is still drawing your frequencies.'); }
        if (st.fqState === 'bad') return err('we couldn’t draw those frequencies. check them, or email us.');
        if (/^wide/.test(st.fqState)) return err('one row of frequencies is too wide for the card. see the note under them.');
      }
    }
    if ((st.back === 'ac' || st.back === 'combo') && !(f.acType || '').trim()) return err('type your aircraft for the back.');
    if ((st.back === 'lf' || st.back === 'combo') && !['lfName', 'lfA1', 'lfA2', 'lfPhone', 'lfEmail'].some(function (k) { return (f[k] || '').trim(); })) return err('add at least one lost & found detail.');
    if (st.back === 'art' && !(f.artDesc || '').trim()) return err('tell us what to engrave on the back.');
    if (st.back === 'tl' && !tlRows()) return err('add at least one rating with the date you passed it.');
    return true;
  }
  function cardProps() {
    var p = {}, f = st.f, sel = addons();
    if (field()) p.Airport = st.code || clean(st.typed);
    // free, so no charge line and no add-on claim; "_freqs checked" is their tick, on the order for the record
    if (fqOn()) { var fr = fqRes().rows; if (fr.length) { p.frequencies = fqText(fr); p['_freqs checked'] = 'yes'; } }
    if (KIND === 'checkride') {
      p.checkride = st.rating;
      if (st.crName.trim()) p['name on card'] = st.crName.trim();
      if (st.crDate.trim()) p['date passed'] = st.crDate.trim();
      var extra = [];
      if (st.ride.trim()) extra.push(st.ride.trim());
      if (st.back === 'cfi' && (f.cfi || '').trim()) extra.push('cfi: ' + f.cfi.trim() + ((f.home || '').trim() ? ' · ' + f.home.trim().toUpperCase() : ''));
      if (extra.length) p['back of card and/or their ride (cfi name and home field)'] = extra.join(' / ');
    }
    if (KIND === 'airline') { var a = airline(st.airline); p.Airline = a ? a.n : norm(st.airline); if (a) { p['Airline ICAO'] = a.i; p.Callsign = a.c; } }
    function set(k, v) { if (v) p[k] = v; }
    if (sel.indexOf('extra frequency') > -1) set('extra freq', [st.freqL, st.freqV].filter(Boolean).join(' '));
    if (sel.indexOf('taxiway + apron') > -1) set('taxiway + apron', 'yes');
    if (sel.indexOf('aircraft outline') > -1) { set('aircraft', f.acType); set('aircraft reg', f.acReg); }
    if (sel.indexOf('lost & found back') > -1) { set('l&f name', f.lfName); set('l&f address', [f.lfA1, f.lfA2].filter(Boolean).join(', ')); set('l&f phone', f.lfPhone); set('l&f email', f.lfEmail); }
    if (sel.indexOf('back art + registration') > -1) { set('back art', f.artDesc); set('back art reg', f.artReg); }
    if (sel.indexOf('training timeline') > -1) { set('timeline', tlRows()); set('timeline total', f.tlTotal); set('timeline name', f.tlName); }
    if (sel.indexOf('second aircraft on the back') > -1) { set('back aircraft', f.air2 || (CFG.variants[0] || {}).title); set('back airline', (f.air2l || '').trim() ? describe(f.air2l) : (p.Airline ? describe(st.airline) : '')); }
    return p;
  }
  var busy = false;
  function add() {
    if (busy) return;
    clearErr();
    if (!validate()) return;
    var sel = addons(), props = cardProps(), q = st.qty;
    var ref = field() ? props.Airport : KIND === 'airline' ? props.Airline : '';
    var items = [{ id: st.variant, quantity: q, properties: props }];
    if (sel.length) {
      var grp = 'g' + Math.random().toString(36).slice(2, 8) + Math.random().toString(36).slice(2, 6);
      props._h15 = grp;
      sel.forEach(function (t) { items.push({ id: HV[t].id, quantity: q, properties: { 'for': ref ? ref + ' card' : 'this card', '_h15': grp } }); });
    }
    busy = true;
    var btn = $('#h15b-add'); btn.disabled = true; btn.textContent = 'adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || ('cart ' + r.status)); return j; }); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (c) { return c.ok ? c.json() : null; }); })
      .then(function (cart) {
        try {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart || {}, sourceId: 'h15-builder', data: { source: 'product-form-component', itemCount: (cart && cart.item_count) || 0 } } }));
        } catch (e) {}
        countCards(cart);
        var d = $('#h15b-done'); d.hidden = false; d.innerHTML = 'added to your bag. <a href="/cart">view bag →</a>';
        openDrawer();
      })
      .catch(function (e) { err('that didn’t go through: ' + String(e.message || e).toLowerCase() + '. try again?'); })
      .then(function () { busy = false; btn.disabled = false; paintPrice(); });
  }
  function openDrawer() {
    try {
      var d = document.querySelector('cart-drawer-component');
      if (d && typeof d.open === 'function') { d.open(); return; }
      var b = document.querySelector('[data-cart-drawer-toggle], .header-actions__cart-icon, a[href="/cart"].header__icon');
      if (b && b.tagName.toLowerCase() === 'button') b.click();
    } catch (e) {}
  }
  function countCards(cart) {
    if (!cart || !cart.items) return;
    st.cartCards = cart.items.reduce(function (n, i) { return n + (CARD_HANDLES.indexOf(i.handle) > -1 ? i.quantity : 0); }, 0);
    paintPrice();
  }
  var addBtn = $('#h15b-add');
  if (addBtn) addBtn.addEventListener('click', add);

  /* ---------- stock line (h15-stock Worker; shows only when low) ---------- */
  function stock() {
    if (CFG.restock || !CFG.stockApi) return;
    fetch(CFG.stockApi, { mode: 'cors', credentials: 'omit', cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d || !d.low) return;
      var left = +d.left, el = $('#h15b-stock');
      if (!isFinite(left)) return;
      el.hidden = false;
      if (left > 0) el.textContent = 'only ' + left + (left === 1 ? ' card' : ' cards') + ' left in this batch';
      else { el.textContent = 'this batch is sold out. new cards are on the way.'; var b = $('#h15b-add'); if (b) { b.disabled = true; b.textContent = 'sold out'; } }
    }).catch(function () {});
  }

  /* ---------- the same field on the rest (homepage art, small) ---------- */
  var HATBOX = 'left:25.81%;top:27.36%;width:48.46%;height:20.1%', ROPEBOX = 'left:29.58%;top:37.10%;width:40.85%;height:17.83%';
  var GARM = { hoodie: { pct: [33.875, 19.312, 32.25, 42.938], pf: [1800, 2400], mask: true }, crewneck: { pct: [30.875, 11.625, 38.188, 50.812], pf: [1800, 2400], chest: [1296, 210] } };
  var KEEP = { polygon: ['points'], path: ['d', 'transform'], text: ['x', 'y', 'text-anchor', 'font-weight', 'font-size', 'letter-spacing'] };
  function safeArt(svg) {
    try {
      var doc = new DOMParser().parseFromString(svg, 'image/svg+xml');
      if (doc.querySelector('parsererror')) return '';
      var out = '';
      [].slice.call(doc.querySelectorAll('polygon, path, text')).forEach(function (n) {
        var tag = n.tagName.toLowerCase(), a = '';
        KEEP[tag].forEach(function (k) { var v = n.getAttribute(k); if (v != null) a += ' ' + k + '="' + esc(v) + '"'; });
        out += tag === 'text' ? '<text' + a + '>' + esc(n.textContent) + '</text>' : '<' + tag + a + '/>';
      });
      return out;
    } catch (e) { return ''; }
  }
  var faceArt = {}, hatInk = {};
  function box(p, mask) { return 'left:' + p[0] + '%;top:' + p[1] + '%;width:' + p[2] + '%;height:' + p[3] + '%' + (mask ? ';-webkit-mask-image:url(' + mask + ');mask-image:url(' + mask + ')' : ''); }
  function wearArt(pid, code) {
    var c = faceArt[code], h = hatInk[code];
    if ((pid === 'hat' || pid === 'rope') && h) return '<svg class="b-art" style="' + (pid === 'hat' ? HATBOX : ROPEBOX) + '" viewBox="0 0 400 175" preserveAspectRatio="none" aria-hidden="true"><g fill="' + (pid === 'hat' ? '#f3f2ee' : '#141414') + '" filter="url(#' + (pid === 'hat' ? 'h15bThreadLight' : 'h15bThreadDark') + ')">' + h + '</g></svg>';
    if (pid === 'hoodie' && c) { var g = GARM.hoodie; return '<svg class="b-art" style="' + box(g.pct, CFG.assets.mask) + '" viewBox="0 0 1800 2400" aria-hidden="true"><svg x="167" y="180" width="1466" height="2160" viewBox="18 40 176.5 260" preserveAspectRatio="none"><g fill="var(--bone)" font-family="Montserrat, sans-serif">' + c + '</g></svg></svg>'; }
    if (pid === 'crewneck' && h) { var k = GARM.crewneck; return '<svg class="b-art" style="' + box(k.pct) + '" viewBox="0 0 1800 2400" aria-hidden="true"><svg class="b-chest" data-cx="' + k.chest[0] + '" data-top="' + k.chest[1] + '" x="0" y="0" width="0" height="0" viewBox="0 0 400 175" preserveAspectRatio="none"><g fill="var(--bone)">' + h + '</g></svg></svg>'; }
    return '';
  }
  function fitChest(host) {
    $$('svg.b-chest', host).forEach(function (inner) {
      var g = inner.querySelector('g'), bb; try { bb = g.getBBox(); } catch (e) { return; }
      if (!bb || !bb.width) return;
      var w = 450, hh = w * bb.height / bb.width;
      inner.setAttribute('viewBox', bb.x + ' ' + bb.y + ' ' + bb.width + ' ' + bb.height);
      inner.setAttribute('x', +inner.getAttribute('data-cx') - w / 2); inner.setAttribute('y', inner.getAttribute('data-top'));
      inner.setAttribute('width', w); inner.setAttribute('height', hh);
    });
  }
  function restArt(code) {
    if (!faceArt[code]) wget('/?code=' + encodeURIComponent(code)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) { var a = t && safeArt(t); if (a) { faceArt[code] = a; paintRest(); } }).catch(function () {});
    if (!hatInk[code]) wget('/?m=hat&code=' + encodeURIComponent(code)).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) { var a = t && safeArt(t); if (a) { hatInk[code] = a; paintRest(); } }).catch(function () {});
  }
  var restCode = '';
  function paintRest() {
    var host = $('#h15b-strip'), sec = $('#h15b-rest');
    if (!host) return;
    var code = st.code || (field() ? '' : (lsGet('h15.airport') || '')) || DEMO;
    var opens = Date.parse(CFG.opensAt || ''), gated = opens && Date.now() < opens;
    var list = (CFG.wear || []).filter(function (w) { return w.url && w.available && !(w.us && (CFG.country !== 'US' || !CFG.hatsLive)); });
    if (!list.length) { sec.hidden = true; return; }
    sec.hidden = false;
    $$('[data-code]', sec).forEach(function (s) { s.textContent = code; });
    if (code !== restCode) { restCode = code; restArt(code); }
    host.style.gridTemplateColumns = 'repeat(' + list.length + ',minmax(0,1fr))';
    host.innerHTML = list.map(function (w) {
      var price = w.gate && gated ? 'oct 14' : money(w.price);
      return '<a href="' + esc(w.url) + '?airport=' + encodeURIComponent(code) + '"><div class="b-wstage"><div class="b-obj"><img class="b-blank" alt="" loading="lazy" src="' + esc(CFG.assets[w.pid]) + '">' + wearArt(w.pid, code) + '</div></div><span>' + esc(w.name) + '</span><span class="b-pr">' + price + '</span></a>';
    }).join('');
    fitChest(host);
  }

  /* ---------- start ---------- */
  buildOpts();
  if (KIND === 'airline') st.f.air2 = (CFG.variants[0] || {}).title || '';
  var start = clean(qs.get('airport') || (/^[a-z0-9]{3,4}$/i.test(qs.get('utm_content') || '') ? qs.get('utm_content') : '') || lsGet('h15.airport') || '');
  if (field() && start.length >= 3) { var ap = $('#h15b-ap'); ap.value = start; st.typed = start; setStatus('', 'checking ' + esc(start) + '…'); lookup(start); }
  paintFront(); paintBack(); paintPrice(); caption(); paintTabs(); paintRest(); stock();
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (c) { return c.ok ? c.json() : null; }).then(countCards).catch(function () {});
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitChest(root); });
})();
